import request from "@/utils/request";

// 种草
export const zhongcao = {
  list: (params) =>
    request({
      url: "/api/backend/order/recommend/list",
      method: "GET",
      params,
    }),
  shipping: (form) =>
    request({
      url: "/api/backend/order/recommend/shipped",
      method: "POST",
      data: { ...form },
    }),
  signature: (order_id) =>
    request({
      url: "/api/backend/order/recommend/signing",
      method: "POST",
      data: { order_id },
    }),
  applicationPass: (order_id) =>
    request({
      url: "/api/backend/order/recommend/success",
      method: "POST",
      data: { order_id },
    }),
  applicationReject: (form) =>
    request({
      url: "/api/backend/order/recommend/reject",
      method: "POST",
      data: { ...form },
    }),
  firstDraftReview: (form) =>
    request({
      url: "/api/backend/order/recommend/first/examine",
      method: "POST",
      data: { ...form },
    }),
  firstDraftSubmit: (form) =>
    request({
      url: "/api/backend/order/recommend/first/submit",
      method: "POST",
      data: { ...form },
    }),
  finalDraftReview: (form) =>
    request({
      url: "/api/backend/order/recommend/final/examine",
      method: "POST",
      data: { ...form },
    }),
  finalDraftSubmit: (form) =>
    request({
      url: "/api/backend/order/recommend/final/submit",
      method: "POST",
      data: { ...form },
    }),
  details: (order_id) =>
    request({
      url: "/api/backend/order/recommend/details",
      method: "GET",
      params: { order_id },
    }),
  integral: (order_id) =>
    request({
      url: "/api/backend/order/recommend/integral",
      method: "POST",
      data: { order_id },
    }),
  updateState: (data) =>
    request({
      url: "/api/backend/order/recommend/up/before/state",
      method: "POST",
      data,
    }),
  updateToStoreAtDatas: (data) =>
    request({
      url: "/api/backend/order/recommend/up/toStoreAtDatas",
      method: "POST",
      data,
    }),
  exportOrderReviewExcel: (params) =>
    request({
      url: "/api/backend/excel/recommend",
      method: "GET",
      params,
    }),
  closeOrderServer: (data) =>
    request({
      url: "/api/backend/order/recommend/cancel",
      method: "POST",
      data,
    }),

};

// 调查问卷
export const questionnaire = {
  list: (params) =>
    request({
      url: "/api/backend/order/questionnaires/list",
      method: "GET",
      params,
    }),
  shipping: (form) =>
    request({
      url: "/api/backend/order/questionnaires/shipped",
      method: "POST",
      data: { ...form },
    }),
  signature: (order_id) =>
    request({
      url: "/api/backend/order/questionnaires/signing",
      method: "POST",
      data: { order_id },
    }),
  applicationPass: (order_id) =>
    request({
      url: "/api/backend/order/questionnaires/success",
      method: "POST",
      data: { order_id },
    }),
  applicationReject: (form) =>
    request({
      url: "/api/backend/order/questionnaires/reject",
      method: "POST",
      data: { ...form },
    }),
  questionnaireTemplate: (questionnaire_id) =>
    request({
      url: "/api/backend/questionnaire/final/examine",
      method: "GET",
      params: { questionnaire_id },
    }),
  integral: (order_id) =>
    request({
      url: "/api/backend/order/questionnaires/integral",
      method: "POST",
      data: { order_id },
    }),
  closeOrderServer: (data) =>
    request({
      url: "/api/backend/order/questionnaires/cancel",
      method: "POST",
      data,
    }),
  updateToStoreAtDatas: (data) =>
    request({
      url: "/api/backend/order/questionnaires/up/toStoreAtDatas",
      method: "POST",
      data,
    }),
};
